import type { Role } from '@/app/store/session.store';

export const PLATFORM_HOME = '/platform/tenants';
export const TENANT_HOME = '/dashboard';

export const homeFor = (role: Role | undefined) => (role === 'PLATFORM_ADMIN' ? PLATFORM_HOME : TENANT_HOME);
